import React, { FC, memo, useCallback, useMemo, useRef, useState } from 'react'

import { TipSectionTransport } from '../../transports/region-landing-page-transport'
import {
    DesktopContainer,
    InnerDesktopContainer,
    StyledCarouselProvider,
    StyledSlider,
    TipsSectionHeading,
    TipsSectionSubHeading,
} from './tips-section-styles'
import TipsSectionCardDesktop from './tips-section-card-desktop'
import { useTranslation } from '../../hooks/locale'
import CarouselButtonBack from './tips-section-button-back'
import CarouselButtonNext from './tips-section-button-next'

type Props = {
    tipsSection: TipSectionTransport
    location: string
}

const TipsSectionDesktop: FC<Props> = ({ tipsSection, location }) => {
    const { heading, tips } = tipsSection
    const { t } = useTranslation()
    const tipsSectionHeading = heading ? heading : `${t('tipsSectionHeading')} ${location}`

    const slides = useMemo(
        () =>
            tips.map(tip => (
                <TipsSectionCardDesktop key={tip.text} tip={tip} totalItems={tips.length} location={location} />
            )),
        [tips, location],
    )

    return (
        <DesktopContainer>
            <TipsSectionHeading>{tipsSectionHeading}</TipsSectionHeading>
            <TipsSectionSubHeading>
                {t('tipsSectionSubHeading')}
                {location}
            </TipsSectionSubHeading>
            <InnerDesktopContainer>
                <StyledCarouselProvider
                    totalSlides={tips.length}
                    visibleSlides={1}
                    naturalSlideWidth={1}
                    naturalSlideHeight={1}
                    isIntrinsicHeight
                    lockOnWindowScroll
                    dragStep={1}
                    step={1}
                >
                    <CarouselButtonBack />
                    <StyledSlider>{slides}</StyledSlider>
                    <CarouselButtonNext numberOfSlides={tips.length} />
                </StyledCarouselProvider>
            </InnerDesktopContainer>
        </DesktopContainer>
    )
}

export default memo(TipsSectionDesktop)
